module.exports = "pegasus/assets/blocks/column-lp5-basic.png";